import { IdentityTypeEnum, SisAbsentZAIDReason } from '@utils/constants';
import { UserManagementMode } from './constants';

export const titleOptions = [
  { label: 'Mr', value: 'Mr' },
  { label: 'Ms', value: 'Ms' },
  { label: 'Mrs', value: 'Mrs' },
  { label: 'Miss', value: 'Miss' },
  { label: 'Doc', value: 'Doctor' },
  { label: 'Prof', value: 'Professor' },
];

export const identityTypeOptions = [
  { label: 'South African ID', value: IdentityTypeEnum.SAIdNumber },
  { label: 'Foreign', value: IdentityTypeEnum.ForeignIdNumber },
];

export const reasonForNoIdOptions = [
  { label: 'Lost ID', value: SisAbsentZAIDReason.LostId },
  { label: 'Stolen ID', value: SisAbsentZAIDReason.StolenId },
  { label: 'Damaged ID', value: SisAbsentZAIDReason.DamagedId },
  { label: 'Not applicable', value: null },
];

export const getValueByUserType = <
  T extends { fallback: unknown; director: unknown; nonDirector: unknown }
>(
  type: UserManagementMode | undefined,
  { fallback, director, nonDirector }: T
): T['director' | 'fallback' | 'nonDirector'] => {
  if (!type) {
    return fallback;
  }

  return type === UserManagementMode.Director ? director : nonDirector;
};
